<template>
    <div>
        <div class="comment_conversion mt-4 pl-0 ml-7">
            <div v-if="ajaxCallInProgress" class="text-center d-flex font-weight-bold align-items-center justify-content-center" style="background-color: #ffffff !important; height: 100vh !important;">
                    <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                <!-- <div>
                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
                </div> -->
            </div>
            <!-- <div v-if="ajaxCallInProgress" class="d-flex align-items-center justify-content-center w-100">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div> -->
            <div v-if="!ajaxCallInProgress && email_show.length == 0" class="text-center font-weight-bold">
                <div>No Emails Found</div>
            </div>
            <div v-else class="" v-for="(email,index) in email_show" :key="index">
                <div class=" justify-content-center email_event" style="width:100%;">
                    <span class="">
                        <span class="fw-600 fs-16">Date: {{dateFormat(email.created_date).split(' ')[0]}}</span>
                        <span class="fw-600 fs-16" style="text-align: center !important;"> {{email.created_date.split('-')[1] + ' ' +  email.created_date.split('-')[2]}}</span>
                        <!-- <span class="fw-500">{{dateFormat(email.created_date).split(' ')[0]}}</span>
                        <span class="fw-500">{{dateFormat(email.created_date).split(' ')[1] + ' ' +  dateFormat(email.created_date).split(' ') [2] }}</span>
                        <span class="fw-400">{{email.created_date.slice(11)}}</span> -->
                    </span>
                </div>
                <div class="mt-4">
                    <div class="d-flex flex-column">
                        <div class="d-flex">
                            <div class="profileCircle">
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" alt="">
                            </div>
                            <div class="d-flex flex-column" >
                                <span class="fs-15 fw-600">{{email.from_name}}</span>
                                <span class="fs-14">{{email.from_email}}</span>
                            </div>
                        </div>
                        <!-- <span class="curve_email"></span> -->
                        <div class="mail_template mr-1">
                            <div  class="bg-white">
                                <p class="ml-3 pt-4 fs-14 fw-500">Subject: {{email.subject}}</p>
                            </div>
                            <div slot="md-expand" v-if="email.is_html_content">
                                <div class="md-card-list-item-content-wrapper" style="display: block; opacity: 1;padding: 10px 20px; box-shadow: 0px 0px 0px 0.5px #aaaaaa;border-radius: 5px">
                                    <div class="md-card-list-item-content">
                                        <p class="p-description-mail" v-html="email.body">
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p class="pl-3" v-html="email.body"></p>
                            </div>
                            <div v-if="email.attachments.length > 0" class=" mb-3 attachment-email">
                                <p class="f-14 fw-500 ">Attachments:</p>
                                <div class="row browse-box w-100 text-center">
                                    <div class="col-lg-6 col-md-12 col-sm-12"  >
                                        <div class="d-flex align-items-center mt-2 file-bg" v-for="(attachment, attachment_index) in email.attachments" :key="attachment_index">
                                            <div class="d-flex align-items-center mr-2" style="width:90%">
                                                <div @click="previewImage(attachment)" class="pointer">
                                                    <img src="/static/images/storage.svg" width="20">
                                                    <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                    <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                    <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                    <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                    <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                    <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                    <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                    <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                    <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                    <img v-else-if="attachment.name.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/txt%20icon.svg">
                                                    <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/> -->
                                                </div>
                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <div class="d-flex justify-content-between pr-5">
                                                        <el-tooltip :content="attachment.name" placement="top">
                                                            <div class="font-weight-bold text-truncate d-block mx-width-220" 
                                                            v-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG') 
                                                            || attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') 
                                                            || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') 
                                                            || attachment.name.endsWith('.mp4') || attachment.name.endsWith('.mp3')" @click="previewImage(attachment)">
                                                                {{attachment.name}}
                                                            </div>
                                                            <div v-else class="font-weight-bold text-truncate d-block mx-width-220">
                                                                {{attachment.name}}
                                                            </div>
                                                        </el-tooltip>
                                                    </div>̀
                                                    <div v-if="attachment.uploading || attachment.url == undefined">
                                                        <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                    </div>
                                                    <div class="d-flex justify-content-between">
                                                        <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                        <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                        <div class="fw-500" style="margin-top: -15px;" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="attachment.hasOwnProperty('url')">
                                                <a class="pointer" :href="attachment.url" download style="text-decoration: none;">
                                                    <i class="icon icon-download"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div v-if="email.attachments.length > 0" class="pl-5 mb-3">
                                <h6>Attachments:</h6>
                                <div class="row w-100 text-center">
                                    <div class="col-lg-6 col-md-12 col-sm-12"  v-for="(attachment, attachment_index) in email.attachments" :key="attachment_index">
                                        <div class="d-flex align-items-center mt-2 file-bg">
                                            <div class="d-flex align-items-center" style="width:90%">
                                                <div @click="previewImage(attachment)" class="pointer">
                                                    <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                    <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                    <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                    <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                    <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                    <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                    <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                    <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                    <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                    <img v-else-if="attachment.name.endsWith('.txt')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/txt%20icon.svg">
                                                    <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/>
                                                </div>
                                                <div class="col">
                                                    <div class="d-flex justify-content-between">
                                                        <el-tooltip :content="attachment.name" placement="top">
                                                            <div class="font-weight-bold text-truncate d-block mx-width-220 pointer" 
                                                            v-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG') 
                                                            || attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') 
                                                            || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') 
                                                            || attachment.name.endsWith('.mp4') || attachment.name.endsWith('.mp3')" @click="previewImage(attachment)">
                                                                {{attachment.name}}
                                                            </div>
                                                            <div v-else class="font-weight-bold text-truncate d-block mx-width-220">
                                                                {{attachment.name}}
                                                            </div>
                                                        </el-tooltip>
                                                    </div>̀
                                                    <div v-if="attachment.uploading || attachment.url == undefined">
                                                        <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                    </div>
                                                    <div class="d-flex justify-content-between">
                                                        <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                        <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                        <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="attachment.hasOwnProperty('url')">
                                                <a class="pointer" :href="attachment.url" download style="text-decoration: none;">
                                                    <i class="icon icon-download"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div class="d-flex justify-content-end p-3 mr-5" v-if="!selectedReply.includes(index+'new')">
                            <button class="btn btn-secondary btn-smm ml-2 fs-14" @click="replyMail(index)">
                            <i class="icon icon-reply text-danger fs-18 pb-1"></i>
                                Reply
                            </button>
                        </div>
                        <div>
                            <div class="" v-if="selectedReply.includes(index+'new')">
                                <div>
                                    <div class="ticket_reply pointer mt-7 mb-5 mr-1">
                                        <div>
                                            <div class="" v-if="email.to_email.email">
                                                <multiselect
                                                    v-validate="'required'"
                                                    class="diginew-multiselect approval-manager mt-2 down-arrow"
                                                    name="ticketType"
                                                    v-model="email['to_email']"
                                                    label="name"
                                                    :allow-empty="false"
                                                    :multiple="false"
                                                    :options="users"
                                                    :searchable="true"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                    placeholder="Enter Email Id"
                                                    :loading="loadingto" @search-change="getAllUsers"
                                                    :blockKeys="['Delete']" track-id="email_id"
                                                >
                                                <template slot="tag" slot-scope="{ option,remove }">
                                                    <span class="custom__tag">
                                                    <span class="filterSelectedNameEmail">{{ option.name }}</span>
                                                        <span class="custom__remove pointer" @click="remove(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfUsersto" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                            <div v-else>
                                                <input v-validate="'required'" name="ticketType" class="inputFieldNew" style="padding-right: 30px !important;" type="email" v-model="email['to_email'].email" placeholder="Enter Email Address" />
                                            </div>
                                            <div class="">
                                                <multiselect
                                                    class="diginew-multiselect approval-manager filter-multiple mt-2 down-arrow"
                                                    v-model="email['cc_list']"
                                                    label="name"
                                                    :multiple="true"
                                                    :options="users"
                                                    :searchable="true"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                    placeholder="Search and Select cc Email Id"
                                                    :loading="loadingcc" @search-change="getAllUsers"
                                                    @remove="remove"
                                                    :blockKeys="['Delete']" track-by="email"
                                                    @input="$forceUpdate()"
                                                >
                                                <template slot="tag" slot-scope="{ option,remove }">
                                                    <span class="custom__tag">
                                                    <span class="filterSelectedNameEmail">{{ option.email }}</span>
                                                        <span class="custom__remove pointer" @click="remove(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfUserscc" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                            <div class="">
                                                <multiselect
                                                    class="diginew-multiselect approval-manager filter-multiple mt-2 down-arrow"
                                                    v-model="email['bcc_list']"
                                                    label="name"
                                                    :multiple="true"
                                                    :options="users"
                                                    :searchable="true"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                    placeholder="Search and Select bcc Email Id"
                                                    :loading="loadingbcc" @search-change="getAllUsers"
                                                    :blockKeys="['Delete']" track-by="email"
                                                    @remove="remove"
                                                    @input="$forceUpdate()"
                                                >
                                                <template slot="tag" slot-scope="{ option,remove }">
                                                    <span class="custom__tag">
                                                    <span class="filterSelectedNameEmail">{{ option.email }}</span>
                                                        <span class="custom__remove pointer" @click="remove(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfUsersbcc" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                            <vue-editor
                                                ondrop="return false;"
                                                class="mt-2"
                                                name="ticket_decription"
                                                maxlength="1000"
                                                :counter="200"
                                                v-model="email['email_body']"
                                                placeholder="Reply Here..."
                                                v-validate="'required'"
                                                :useCustomImageHandler="true"
                                                @image-added="handleImageAdded"
                                                :editorToolbar="customToolbar"
                                                @text-change="onTextChange(email.email_body)"
                                                @input="$forceUpdate()"
                                                ref="editor"
                                            ></vue-editor>
                                            <span class="pull-right text-right text-black font-600 fs-12">{{ 1000 - email.email_body.length}}/{{1000}}</span>
                                        </div>
                                    </div>
                                    <div class="header fs-15 fw-500 mb-2">
                                            Attachments
                                            <span style="position:absolute;margin-top:-10px;left:auto; margin-left: -2px;">
                                                <el-tooltip class="item pull-right" effect="dark" content="Supports .doc, .docx, .pdf, .ppt, .pptx, .txt, .xls,
                                                    .xlsx,.bmp, .gif, .jpeg, .png, .svg, .tiff, .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv
                                                    Size limit- 25.00 MB (Max. 10 files)" placement="top">
                                                    <i class="ri-2x ri-information-line text-black fs-16"></i>
                                                </el-tooltip>
                                            </span>
                                        </div>
                                    <div class="attachments attachment-email my-2 mr-1">
                                        
                                        <div class="row mr-7 ml-0">
                                            <div class="col-lg-12 col-md-12 col-sm-12 bg-grey-box w-100 text-center pb-3" @drop="dropEmailAttachment($event, i)" @dragover="dragOverAttachment($event)">
                                                <div class="mt-4">
                                                    <img  src="/static/images/draganddrop.svg" width="50" class="upload-img mb-2 pr-4">
                                                    <span data-v-c18eb76e="" class="fs-14 fw-500 mt-2 pr-8 text-center">
                                                        Drag and Drop File
                                                    </span>
                                                    <span class="pr-8 hide-on-mob " style="font-weight:600 !important;">OR</span>
                                                    <file-upload id="multiple" v-if="email_attachments.length < 5"
                                                        class="choose-file btn btn-new-primary"
                                                        accept=".doc, .docx, .pdf, .ppt, .pptx, .txt, .xls, .xlsx, .bmp, .gif, .jpeg, .png, .svg, .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv, .mov, .csv,.ods,.zip,.xls,image/*"
                                                        @input-file="uploadFromEmailAttachment($event)"
                                                        style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                                        <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                                        Click to Upload
                                                    </file-upload>
                                                    <!-- <label class="choose-file btn btn-new-primary" v-if="email_attachments.length < 5">
                                                        <input id="multiple" type="file" @change="uploadFromEmailAttachment($event)" accept=".doc, .docx, .pdf, .ppt, .pptx, .txt, .xls, .xlsx, .bmp, .gif, .jpeg, .png, .svg, .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv, .mov, .csv,.ods,.zip,.xls,image/*">
                                                        Click to Upload
                                                    </label> -->
                                                    <label class="choose-file btn-upload" style="background-color: grey;cursor: not-allowed" v-else>
                                                        Browse
                                                    </label>
                                                    <!-- <button class="btn btn-secondary-browse text-capitalize">Browse</button> -->
                                                <!-- <div class="text-center mt-4 mb-2 fs-13px">
                                                    Supports .doc, .docx, .pdf, .ppt, .pptx, .txt, .xls, <br>
                                                    .xlsx,.bmp, .gif, .jpeg, .png, .svg, .tiff, .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv <br>
                                                    Size limit- 25.00 MB (Max. 10 files)
                                                </div> -->
                                            </div>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 pl-0" v-if="email_attachments.length > 0">
                                                <div class="row browse-box w-100 text-center" style="overflow: auto;">
                                                    <div class="col-lg-6 col-md-12 col-sm-12">
                                                        <div class="d-flex align-items-center mt-2 file-bg" v-for="(attachment, attachment_index) in email_attachments" :key="attachment_index">
                                                            <div class="d-flex align-items-center" style="width:90%">
                                                                <div>
                                                                    <img @click="previewImage(attachment)" class="pointer" src="/static/images/storage.svg" width="20">
                                                                    <!-- <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                    <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/> -->
                                                                </div>
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="d-flex justify-content-between">
                                                                        <el-tooltip :content="attachment.name" placement="top">
                                                                            <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                {{attachment.name}}
                                                                            </div>
                                                                        </el-tooltip>
                                                                    </div>
                                                                    <div v-if="attachment.uploading || attachment.url == undefined">
                                                                        <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                    </div>
                                                                    <div class="d-flex justify-content-between">
                                                                        <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                        <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                        <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="pointer ml-3" style="width:10%; z-index: 1;" @click="deleteEmailAttachment(attachment_index)">
                                                                <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                <i class="icon icon-trash text-black fs-20" v-if="attachment.url"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end mt-10 mb-10 mr-2">
                                        <button type="button" class="btn btn-danger-new" style="box-shadow: none;" @click="replyMail(index)">
                                            Discard
                                        </button>
                                        <button type="button" :disabled="isMailSent || isUploadingInProgress" class="btn btn-green  ml-3 mr-5" style="box-shadow: none;" @click="mailSend(index)">
                                            Send
                                        </button>
                                    </div>
                                    <!-- <div class="attachments my-2">
                                        <div class="header fw-500 mb-2">
                                            Attachments
                                        </div>
                                        <div class="row mr-7 ml-0">
                                            <div class="border-dotted" @drop="dropEmailAttachment($event, i)" @dragover="dragOverAttachment($event)" :class="email_attachments.length > 0 ? 'col-lg-4 col-md-6 col-sm-12' : 'col-12'">
                                                <div class="p-2 d-flex align-items-center flex-column">
                                                    <img data-v-c18eb76e="" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/upload-icon.svg" width="30" class="upload-img mb-2">
                                                    <div data-v-c18eb76e="" class="fs-14 fw-500 mb-2">
                                                        Drag and Drop File or 
                                                    </div>
                                                    <label class="choose-file btn-upload" v-if="email_attachments.length < 5">
                                                        <input id="multiple" type="file" @change="uploadFromEmailAttachment($event)" accept=".doc, .docx, .pdf, .ppt, .pptx, .txt, .xls, .xlsx, .bmp, .gif, .jpeg, .png, .svg, .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv, .mov, .csv,.ods,.zip,.xls,image/*">
                                                        Browse
                                                    </label>
                                                    <label class="choose-file btn-upload" style="background-color: grey;cursor: not-allowed" v-else>
                                                        Browse
                                                    </label>
                                                    <button class="btn btn-secondary-browse text-capitalize">Browse</button>
                                                </div>
                                                <div class="text-center mt-4 mb-2 fs-13px">
                                                    Supports .doc, .docx, .pdf, .ppt, .pptx, .txt, .xls, <br>
                                                    .xlsx,.bmp, .gif, .jpeg, .png, .svg, .tiff, .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv <br>
                                                    Size limit- 25.00 MB (Max. 10 files)
                                                </div>
                                            </div>
                                            <div class="col-lg-8 col-md-6 col-sm-12" v-if="email_attachments.length > 0">
                                                <div class="row browse-box w-100 text-center" style="overflow: auto;">
                                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                                        <div class="d-flex align-items-center mt-2 file-bg" v-for="(attachment, attachment_index) in email_attachments" :key="attachment_index">
                                                            <div class="d-flex align-items-center" style="width:90%">
                                                                <div>
                                                                    <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                    <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/>
                                                                </div>
                                                                <div class="col">
                                                                    <div class="d-flex justify-content-between">
                                                                        <el-tooltip :content="attachment.name" placement="top">
                                                                            <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                {{attachment.name}}
                                                                            </div>
                                                                        </el-tooltip>
                                                                    </div>
                                                                    <div v-if="attachment.uploading || attachment.url == undefined">
                                                                        <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                    </div>
                                                                    <div class="d-flex justify-content-between">
                                                                        <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                        <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                        <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="pointer ml-3" style="width:10%; z-index: 1;" @click="deleteEmailAttachment(attachment_index)">
                                                                <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
    </div>
</template>
<script>
import {
    EventBus
} from '../eventBus/nav-bar-event.js';
const Preview = () => import("../Preview");
import { VueEditor } from "vue2-editor";
var mime = require('mime-types')
import attachments from "../mixins/attachments.js";
import ticket from '../mixins/ticket.js';
import FileUpload from 'vue-upload-component';
import { SweetModal } from 'sweet-modal-vue';
import convert from '../mixins/convert.js';
import axios from 'axios';
export default {
    props:['showDetails'],
    mixins: [attachments,ticket,convert],
    components:{
        VueEditor,
        FileUpload,
        SweetModal,
        Preview
    },
    data(){
        return{
            mail_notes:'',
            attachments:[],
            search_key:'',
            emails:[],
            to_email_options:[],
            ccEmail:[],
            cc_email_options:[],
            bccEmail:[],
            bcc_email_options:[],
            email_show:[],
            ajaxCallInProgress:false,
            temp_attachments:[],
            accept: '*',
            extensions: '*',
            size: 1024 * 1024 * 10,
            multiple: true,
            directory: true,
            description_length: 0,
            drop: true,
            limit: 993,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            postAction: '/upload/post',
            putAction: '/upload/put',
            headers: {
                'X-Csrf-Token': 'xxxx',
            },
            data: {
                '_csrf_token': 'xxxxxx',
            },
            autoCompress: 1024 * 1024,
            loading:false,
            loadingto: false,
            loadingcc: false,
            loadingbcc: false,
            scrollable:false,
            temp_users:[],
            count:0,
            visible:false,
            users:[],
            list_users:[],
            success_msg:'',
            warning_msg:'',
            selectedReply:[],
            isMailSent: false,
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ 'align': ''},{ 'align': 'justify'}, { 'align': 'right' }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link","image"]
            ],
            email_attachments: [],
            preview_visible:false,
            preview_file:{},
        }
    },
    methods:{
        onTextChange(email) {
            const quill = this.$refs.editor[0].quill
            console.log(quill)
            const len = quill.getLength()
            this.description_length = len-1
            if (len > this.limit) {
                quill.deleteText(this.limit, len);
            }
        },
        hidePreview(){
            this.preview_visible = false
        },
        deleteEmailAttachment(attachment_index){
            this.email_attachments.splice(attachment_index, 1)
            this.$forceUpdate()
        },
        dragOverAttachment(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        dropEmailAttachment(evt) {
            evt.preventDefault();
            if(this.email_attachments.length + [...evt.dataTransfer.files].length <= 5){
                [...evt.dataTransfer.files].forEach((file, i) => {
                    this.uploadFromDropEmailAttachment(file)
                });
            } else {
                this.$toasted.global.error("Attachments limit should not exceed more than 5")
            }
        },
        previewImage(file) {
            EventBus.$emit('ZindexChangeStart')
            // if(file.name.endsWith('.mp4') || file.name.endsWith('.mp3') || file.name.endsWith('.png') || file.name.endsWith('.PNG') || file.name.endsWith('.jpg') || file.name.endsWith('.jpeg') || file.name.endsWith('.JPG') || file.name.endsWith('.JPEG')){
            //     let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            //     file['content_type'] = content_type;
            //     this.preview_file = file;
            //     this.preview_visible = true;
            // }
            this.$emit('previewImage', file)
        },
        uploadFromDropEmailAttachment(event) {
            const total_allowed_size = 256000
            let total_size_occupied = this.email_attachments.reduce((a, b) => a + parseInt(b.size), 0)
            if(event) {
                var input = event;
            }
            if(total_allowed_size > parseInt((input.size * 0.001).toFixed(3)) &&  total_allowed_size > total_size_occupied){
                let contains_duplicates = false
                this.email_attachments.forEach((e) => {
                    if(e.name == event.name){
                        contains_duplicates = true
                    }
                })
                if(!contains_duplicates){
                    if (input && event) {
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
                        let attachment = {
                            name: input.name,
                            size: JSON.stringify(input.size),
                            source: source,
                            progress: 0,
                            created_time: new Date(),
                            error: ""
                        }
                        this.email_attachments.push(attachment) 
                        this.getResumableURL(input, this.email_attachments[this.email_attachments.length - 1]);
                    }
                } else {
                    this.$toasted.global.error("This file is already uploaded")
                }
            } else {
                this.$toasted.global.error("Total File sizes must be less than 25MB")
            }
        },
        uploadFromEmailAttachment(event) {
            const total_allowed_size = 256000
            let total_size_occupied = this.email_attachments.reduce((a, b) => a + parseInt(b.size), 0)
            if(event) {
                console.log(event.file)
                var input = event.file;
            }
            if(total_allowed_size > parseInt((input.size * 0.001).toFixed(3)) && total_allowed_size > total_size_occupied){
                let contains_duplicates = false
                this.email_attachments.forEach((e) => {
                    if(e.name == event.name){
                        contains_duplicates = true
                    }
                })
                if(!contains_duplicates){
                    if (input && event) {
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
                        let attachment = {
                            name: input.name,
                            size: JSON.stringify(input.size),
                            source: source,
                            progress: 0,
                            created_time: new Date(),
                            error: ""
                        }
                        this.email_attachments.push(attachment) 
                        this.getResumableURL(input, this.email_attachments[this.email_attachments.length - 1]);
                    }
                } else {
                    this.$toasted.global.error("This file is already uploaded")
                }
            } else {
                this.$toasted.global.error("Total File sizes must be less than 25MB")
            }
        },
        getResumableURL(file, attachment) {
            this.isUploadingInProgress = true;
            attachment.uploading = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
                this.$forceUpdate()
            })
            .catch(error => {
                console.log(error.data.reason)
            })
        },
        replyMail(index){
            let newValue = index +'new'
            if (this.selectedReply.find(x => x === newValue)) {
                this.selectedReply = this.selectedReply.filter(function(x) {
                    if (x !== newValue) {
                        return x
                    }
                })
                this.email_show[index].cc_list = []
                this.email_show[index].bcc_list = []
                this.email_show[index].email_body = ''
            }else{
                this.selectedReply.push(newValue)
            }
            this.$forceUpdate();
        },
        handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            let data = new FormData()
            data.append('file', file)
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                onUploadProgress: function (progressEvent) {
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                Editor.insertEmbed(cursorLocation, "image", resumable_url);
                resetUploader();
            })
            .catch(error => {
            })
        },
        mailSend(index){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    let details = this.email_show[index]
                    let params= {
                        attachments:this.email_attachments,
                        bcc_list:details['bcc_list'] || [],
                        cc_list:details['cc_list'] || [],
                        email_body:details['email_body'].replace('<p>','').replace('</p>', '') || '',
                        from_email:{
                            name:details.from_name,
                            email:details.from_email
                        },
                        replied_to:details._id,
                        subject:details.subject,
                        ticket_id:details.ticket_id,
                        to_email:details.to_email
                    }
                    this.confirmReply(params,index)
                }else{
                    this.$toasted.global.error("Please Fill Email Text To Send")
                }
            })
        },
        async confirmReply(params,index){
            try {
                this.isMailSent = true
                let res = await this.replytoEmail(params)
                this.success_msg = res.response
                this.email_attachments = []
                this.replyMail(index)
                this.getReplyMail()
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
            this.isMailSent = false
        },
        handelDuplicates(){
            const result = [];
            const map = new Map();
            for (const item of this.users) {
                if(!map.has(item.email)){
                    map.set(item.email, true);    // set any value to Map
                    result.push({
                        email:item.email,
                        name:item.name
                    })
                }
            }
            this.users = result
        },
        async getAllUsers(search_key){
            try {
                this.loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let response = await this.getUserEmails(params)
                this.list_users = response.response.emails
                this.list_users.forEach((el,index)=>{
                    let value = {
                        email:el.email_id,
                        name:el.name
                    }
                    this.users.push(value)
                })
                this.count = this.temp_users.length
                this.loading = false
                this.scrollable = false
                this.handelDuplicates()
            } catch (reason) {

            }
        },
        // async reachedEndOfUsers(reached){
        //     this.visible = reached
        //     if (reached) {
        //         if (this.scrollable == false) {
        //             this.loading = true
        //             let params ={
        //                 skip:this.count,
        //                 limit:10,
        //                 search_key:this.search_key
        //             }
        //             let response = await this.getUserEmails(params)
        //             this.temp_users = response.response.emails.length;
        //             if (response.response.skip == this.count) {
        //                 if (this.temp_users > 0) {
        //                     let tempFiles = response.response.emails;
        //                     tempFiles.forEach(el => {
        //                         this.list_users.push(el);
        //                         this.list_users.forEach((el,index)=>{
        //                             let value = {
        //                                 email:el.email_id,
        //                                 name:el.name
        //                             }
        //                             this.users.push(value)
        //                         })
        //                     });
        //                     this.count += response.response.emails.length;
        //                     this.loading = false
        //                 } else {
        //                     this.scrollable = true
        //                     this.loading = false
        //                 }
        //                 this.handelDuplicates()
        //             }
        //             this.loading = false
        //         }
        //     }
        // },
        async reachedEndOfUsersto(reached){
            this.visible = reached
            if (reached) {
                if (this.scrollable == false) {
                    this.loadingto = true
                    let params ={
                        skip:this.count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserEmails(params)
                    this.temp_users = response.response.emails.length;
                    if (response.response.skip == this.count) {
                        if (this.temp_users > 0) {
                            let tempFiles = response.response.emails;
                            tempFiles.forEach(el => {
                                this.list_users.push(el);
                                this.list_users.forEach((el,index)=>{
                                    let value = {
                                        email:el.email_id,
                                        name:el.name
                                    }
                                    this.users.push(value)
                                })
                            });
                            this.count += response.response.emails.length;
                            this.loadingto = false
                        } else {
                            this.scrollable = true
                            this.loadingto = false
                        }
                        this.handelDuplicates()
                    }
                    this.loadingto = false
                }
            }
        },
        async reachedEndOfUserscc(reached){
            this.visible = reached
            if (reached) {
                if (this.scrollable == false) {
                    this.loadingcc = true
                    let params ={
                        skip:this.count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserEmails(params)
                    this.temp_users = response.response.emails.length;
                    if (response.response.skip == this.count) {
                        if (this.temp_users > 0) {
                            let tempFiles = response.response.emails;
                            tempFiles.forEach(el => {
                                this.list_users.push(el);
                                this.list_users.forEach((el,index)=>{
                                    let value = {
                                        email:el.email_id,
                                        name:el.name
                                    }
                                    this.users.push(value)
                                })
                            });
                            this.count += response.response.emails.length;
                            this.loadingcc = false
                        } else {
                            this.scrollable = true
                            this.loadingcc = false
                        }
                        this.handelDuplicates()
                    }
                    this.loadingcc = false
                }
            }
        },
        async reachedEndOfUsersbcc(reached){
            this.visible = reached
            if (reached) {
                if (this.scrollable == false) {
                    this.loadingbcc = true
                    let params ={
                        skip:this.count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserEmails(params)
                    this.temp_users = response.response.emails.length;
                    if (response.response.skip == this.count) {
                        if (this.temp_users > 0) {
                            let tempFiles = response.response.emails;
                            tempFiles.forEach(el => {
                                this.list_users.push(el);
                                this.list_users.forEach((el,index)=>{
                                    let value = {
                                        email:el.email_id,
                                        name:el.name
                                    }
                                    this.users.push(value)
                                })
                            });
                            this.count += response.response.emails.length;
                            this.loadingbcc = false
                        } else {
                            this.scrollable = true
                            this.loadingbcc = false
                        }
                        this.handelDuplicates()
                    }
                    this.loadingbcc = false
                }
            }
        },
        async getReplyMail(){
            try {
                this.ajaxCallInProgress = true
                let params = {
                    ticket_id:this.showDetails.ticket_id
                }
                let res = await this.getReplyEmails(params)
                this.email_show = res.response
                this.email_show.forEach((el,index)=>{
                    el['to_email'] = {
                        email:el.to_email,
                        name:el.to_name
                    }
                })
                this.email_show.forEach((el, el_index) => {
                    if(!el.is_html_content){
                        let find_img = el.body.split(' ')
                        let new_arr = []
                        if(!find_img.includes('<!DOCTYPE')){
                            find_img.forEach((im, im_index) => {
                                let regex = /[a-zA-Z0-9]{1,}<img+/i
                                if(regex.test(im)){
                                    new_arr.splice(im_index, 0, 'class="w-100"')
                                    new_arr.splice(im_index, 0, im)
                                } else if(im == '<img'){
                                    new_arr.splice(im_index, 0, 'class="w-100"')
                                    new_arr.splice(im_index, 0, im)
                                } else if(im.endsWith('><img')){
                                    let d = im.slice(0,im.length-4)
                                    new_arr.push(d)
                                    new_arr.push('<img class="w-100"')
                                } else {
                                    new_arr.push(im)
                                }
                            })
                        }
                        el.body = new_arr.join(" ")
                    }
                })
                this.ajaxCallInProgress = false
            } catch (reason) {
                console.log(reason)
                this.ajaxCallInProgress = false
            }
        },
        removeCc(option){
            this.product.forEach((el,index)=>{
                if(el._id == option._id){
                    this.product.splice(index,1)
                }
            })
        },
    },
    async mounted(){
        this.getReplyMail()
    },
}
</script>
<style scoped>
.comment_conversion{
    padding: 10px 0px 10px 15px;
    border-bottom: none;
    /* border-top: 1px solid #aac6ee; */
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    max-height: 100%;
    min-width: auto;
}
.email_line{
  border-left: 1px solid #005dae;
}
.email_line .email_event:before,
.email_line .email_event:after {
    position: absolute;
    display: block;
    top: 0;
}
.email_line .email_event .unfinishedCircle {
  background: #005dae;
  border-radius: 50%;
  height: 75px;
  width: 75px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  margin-right: 20px;
  position: relative;
  right: 49px;
}
.profileCircle  img{
  height: 50px;
  width: 50px;
  margin-right: 20px;
}
.mail_template{
    /* background-color: #f2f3f5; */
    border-radius: 10px;
}
.mail_reply{
    background-color: #f2f3f5;
    border-radius: 10px;
}
.curve_email{
    border: solid transparent;
    border-top-color: transparent;
    border-width: 13px;
    border-bottom-color: #f2f3f5;
    width: 5px;
    border-radius: 0px;
    margin-left: 10px;
}
.ticket_reply{
    border-radius: 10px;
    /* box-shadow: -1.5px 2.5px 3px 0 rgba(0, 0, 0, 0.16); */
    /* background-color: #f2f3f5; */
}
#file_attach{
    position: relative;
    bottom: 260px;
    left: 670px;
    display: flex;
    align-items: center;
    width: 50px;
}
.to_reply{
    border: none !important;
    border-bottom: 1px solid #bfc1c3 !important;
    border-radius: 0px !important;
    margin-top: 0px !important;
}
.p-description-mail {
    white-space: normal !important;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    color: #4e5764;
    margin-bottom: 30px;
    /* padding-left: 32px; */
}
.p-description-mail {
    overflow-y: visible !important;
    overflow-x: scroll;
}
.description-content{
    line-break: anywhere;
    white-space: pre-wrap;
}
.md-card-list-item-content-wrapper{
    background-color: #fff;
}
.border-dotted{
    border: 1px dashed #000000
}
.btn-secondary-browse{
    background-color: #00448b;
    color: #fff !important;
    border-radius: 10px !important;
    font-weight: 500;
}
.btn-upload {
    background: #00448b;
    border-radius: 15px !important;
    text-transform: none !important;
    padding: 6px 18px !important;
    font-weight:500 !important;
}
.btn-upload-disabled{
    background: #e8e8e8 !important;
    border-radius: 15px !important;
    text-transform: none !important;
    padding: 6px 18px !important;
    font-weight:500 !important;
}
.browse-box{
    height: 250px;
}
.bg-grey-box{
    background: #f1f3f4
}
.file-bg{
    background-color: #f1f1f1;
    padding: 10px;
    border-radius: 2px;
}
.fs-13px{
    font-size: 13px;
}
.attachment-email {
    padding: 6.4px 7.9px 6.5px 27.5px;
    border-radius: 4px;
    border: solid 0.5px #dfe6e9;
}
</style>